import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderActions","MobileMenu"] */ "/vercel/path0/src/components/common/HeaderClient.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/for_architects.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/for_engineers.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/for_programmers.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/logo_written.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/logo.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/logos/bbc.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/logos/cbs.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/logos/cnn.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/logos/fast-company.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/logos/forbes.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/logos/huffpost.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/logos/techcrunch.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/logos/wired.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/qr-code.svg");
